import React from 'react'

import close from './../../../UI/loading/cerrar.svg'

interface Props{
    isVideo: boolean
    handleOpenTutorialVideo: any,
    links: string
}

interface State{}

class VideoComponent extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        console.log(this.props.isVideo, this.props.links);
        return(
            <div className={this.props.isVideo ? 'main-tuto-container fade-in':'main-tuto-container fade-out'}>
                <div className='tuto-close-btn' onClick={() => {this.props.handleOpenTutorialVideo(this.props.isVideo ? -1:"")}}>
                    <img src={close}/>
                </div>
                <div className='video-tuto-container'>
                    <iframe 
                        src={this.props.isVideo ? this.props.links +"?rel=0?version=3&autoplay=1&controls=0&loop=1&showinfo=0":""} 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"   
                        className={this.props.isVideo ? 'fade-in':'fade-out'} 
                    />
                </div>
            </div>
        )
    }
}

export default VideoComponent